import { ImageActionType } from './image-action-type';
import { RedirectingAction } from '../interfaces';

export interface UploadImageRequestAction extends RedirectingAction {
  imageKey: string;
  file: File;
  type: ImageActionType.UploadRequest;
}

export const uploadImageRequest = (
  imageKey: string,
  file: File,
  options: RedirectingAction = {},
): UploadImageRequestAction => ({
  ...options,
  file,
  imageKey,
  type: ImageActionType.UploadRequest,
});
